export default __webpack_public_path__ + "static/media/shrreya.b49ff5ae.jpeg";